import _fetch from './fetch'
const getUserInfo = async (params?: object | undefined) => {
  const response = await _fetch('/aigc/api/user/info', {
    method: 'GET',
    params: params
  })
  const res = await response.json()
  if (res.code === 200) {
    window.isLoggedIn = true
    // 埋点
    window.dataLayer &&
      window.dataLayer.push({
        user_name: res.data?.nickName || '',
        userId: res.data?.userId || '',
        from_link: sessionStorage.getItem('ht_source') || ''
      })
    window.gtag &&
      window.gtag('event', 'enter_homepage', {
        user_name: res.data?.nickName || '',
        userId: res.data?.userId || '',
        from_link: sessionStorage.getItem('ht_source') || ''
      })
  } else {
    window.dataLayer &&
      window.dataLayer.push({
        from_link: sessionStorage.getItem('ht_source') || ''
      })
    window.gtag &&
      window.gtag('event', 'enter_homepage', {
        from_link: sessionStorage.getItem('ht_source') || ''
      })
  }
  // 埋点nickName
  return res
}
export default getUserInfo
